import { Edit, X } from 'lucide-react'
import { useEffect, useState } from 'react'

import type { OrganizationDetail } from '@ankor-io/common/types/account'

// import { Avatar } from '@/ui-components/Avatar'
import { Button } from '@/ui-components/Button'
import { DialogActions, DialogBody, DialogTitle } from '@/ui-components/Dialog'
import { Input } from '@/ui-components/Input'

export type OrganizationEditModalContentProps = {
  organization: OrganizationDetail
  setOrganization: (form: OrganizationDetail) => void
  onSave: () => void
  onCancel: () => void
  isEditSaving: boolean
}

const OrganizationEditModalContent = ({
  organization,
  setOrganization,
  onSave,
  onCancel,
  isEditSaving,
}: OrganizationEditModalContentProps) => {
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    setIsSaving(isEditSaving)
  }, [isEditSaving])

  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-x-2">
          <Edit className="size-5 text-gray-900 dark:text-white" />
          <DialogTitle>Edit Organization</DialogTitle>
        </div>
        <Button
          plain
          onClick={onCancel}
          data-testid="close-modal-btn"
        >
          <X data-slot="icon" />
        </Button>
      </div>

      <DialogBody>
        <div className="space-y-8">
          <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">Organization Name</label>
          <Input
            value={organization.name}
            placeholder="Enter organization name"
            onChange={(e) => setOrganization({ ...organization, name: e.target.value })}
          />

          <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
            Organization Description
          </label>
          <Input
            value={organization.description}
            placeholder="Enter organization description"
            onChange={(e) => setOrganization({ ...organization, description: e.target.value })}
          />

          {/* TODO: add logo */}
          {/* <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">Logo URL</label>
          <Input
            value={organization.logo}
            placeholder="Enter logo URL"
            onChange={(e) => setOrganization({ ...organization, logo: e.target.value })}
          /> 

          {organization.logo && (
            <div className="flex items-center gap-3 px-4 py-2 bg-gray-50 dark:bg-gray-800 rounded-lg">
              <span className="text-sm text-gray-600 dark:text-gray-400">Preview:</span>
              <Avatar
                src={organization.logo}
                alt="Logo preview"
                className="size-12"
              />
            </div>
          )} */}
        </div>
      </DialogBody>

      <DialogActions>
        <Button
          plain
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          color="blue"
          onClick={onSave}
          disabled={!organization.name.trim() || isSaving}
          className={isSaving ? 'cursor-not-allowed opacity-50' : ''}
        >
          {isSaving ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </>
  )
}

export default OrganizationEditModalContent
